
import EventSticker from "./EventSticker";
import EventStickerByPromotion from "./EventStickerByPromotion";
import style from "./Sticker.module.css";

function Sticker(props) {
    const { isEvent, discount, price, sticker } = props;


    return (
        <div className={style.stickerWrap}>
            {
                {
                    product: <EventSticker isEvent={isEvent} discount={discount} price={price}/>,
                    promotion: <EventStickerByPromotion isEvent={isEvent} discount={discount} price={price}/>
                }[sticker]

            }
        </div>
    )
}

export default Sticker;